import React from "react";

function InputField({ placeholder, className, value, onChange }) {
  return (
    <input
      className={`input ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}

export default InputField;
